<template>
  <div :class="colClass">
    <component
      :is="component"
      :path="path"
      :label="field.label"
      :groupReadOnly="groupReadOnly"
      :upload-operation-id="fieldProps || 'DocStorage_uploadDocument'"
    ></component>
  </div>
</template>

<script>
import { isCheckboxList, isDate, isDocumentProp, isMap, isRadioList, isRating, isSubForm } from '../../form'
import EventBus from '../../utils/event-bus'

export default {
  name: 'FormFieldStoreWrapper',
  props: {
    path: {
      type: String,
    },
    groupReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    component() {
      return () =>
        import(
          `${this.isSubForm ? './SubFormStore.vue' : isDocumentProp(this.field) ? './store-controls/DocumentPropStore.vue' : isMap(this.field) ? './store-controls/LeafletControlStore.vue' : './FormFieldStore.vue'}`
        )
    },
    colClass() {
      let defaultClassNames = `col-sm-12`
      if (!isSubForm(this.field)) {
        defaultClassNames += ` col-md-6`
      }
      let classNames = ``
      if (isDate(this.field)) {
        classNames = `col-xl-${this.field.posSizex} col-sm-6 date`
      } else if (isRating(this.field)) {
        classNames = `col-xl-${this.field.posSizex} col-sm-6`
      } else if (isCheckboxList(this.field) || isRadioList(this.field)) {
        classNames = `col-xl-${this.field.posSizex}`
      } else {
        if (this.field.posSizex.toString() === '4') {
          classNames = `col-xl-${this.field.posSizex}`
        } else {
          classNames = `col-xl-${this.field.posSizex}`
        }
      }
      return defaultClassNames.concat(' ' + classNames)
    },
    isSubForm() {
      return this.field.subForm
    },
    field() {
      return this.$get('fieldByPath')(this.path)
    },
    fieldProps() {
      return Object.assign(this.field, this.field.inputOptions).uploadOperationId
    },
    idForm() {
      return this.$get('idForm')
    },
  },
  methods: {
    isDocumentProp,
    isMap,
  },
  beforeUpdate() {
    EventBus.$emit('update-start', { idForm: this.idForm })
  },
  updated() {
    EventBus.$emit('update-end', { idForm: this.idForm })
  },
}
</script>
